import { useEffect, useState } from 'react'
import { Spinner } from '@carouselgg/nexus/spinner'
import { useShellFallback } from '../shell-fallback'

/** `useShellFallback` for places that can't call a hook (class error boundaries). */
export function ShellFallback() {
  useShellFallback()
  return null
}

/** Quiet period before the spinner appears, so a fast load shows nothing at all. */
const SHOW_DELAY_MS = 300
/** A loader mounting this soon after another was visible shows straight away. */
const CONTINUITY_MS = 500

// Loading a remote route is two phases — the chunk, then the org — each with
// its own loader. Remembering when one was last on screen stops the second from
// restarting the quiet period, which would blink the spinner off and on again.
let lastVisibleAt = 0

/** Full-viewport loader shared by the host and its remotes, so both phases sit in one place. */
export function RemotePageLoading() {
  const [visible, setVisible] = useState(() => Date.now() - lastVisibleAt < CONTINUITY_MS)

  useEffect(() => {
    if (visible) return
    const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS)
    return () => clearTimeout(timer)
  }, [visible])

  useEffect(() => {
    if (!visible) return
    return () => { lastVisibleAt = Date.now() }
  }, [visible])

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100dvh' }}>
      {visible && <Spinner size="lg" variant="gradient" />}
    </div>
  )
}
